import { Component, input, output } from '@angular/core';
import { IconComponent } from '@shared/components';

@Component({
    selector: 'app-menu-header',
    templateUrl: './menu-header.component.html',
    styleUrls: ['./menu-header.component.css'],
    imports: [IconComponent],
})
export class MenuHeaderComponent {
    readonly label = input.required<string>();
    readonly collapsed = input(false);

    readonly toggleCollapse = output<void>();
}
